import { combineReducers } from "redux";
import { clientesReducer } from "./redux/clientes";
import { devolucionesReducer } from "./redux/devoluciones";
import { estadosIncidenciaFullfilledReducer } from "./redux/estadosIncidencia";
import { estadosVentaFullfilledReducer } from "./redux/estadosVenta";
import { piezasReservadasReducer } from "./redux/piezasReservadas";
import { facturasReducer } from "./redux/facturas";
import { familiaPiezaFullfilledReducer } from "./redux/familiaPiezas";
import { incidenciasReducer } from "./redux/incidencias";
import { marcasFullfilledReducer } from "./redux/marcas";
import { modelosFullfilledReducer } from "./redux/modelos";
import { paisesFullfilledReducer } from "./redux/paises";
import { plataformasFullfilledReducer } from "./redux/plataformas";
import { poblacionesFullfilledReducer } from "./redux/poblaciones";
import { presupuestosReducer } from "./redux/presupuestos";
import { proveedoresReducer } from "./redux/proveedores";
import { rolesFullfilledReducer } from "./redux/roles";
import { searchReducer } from "./redux/features/search";
import { tipoClientesFullfilledReducer } from "./redux/tipoClientes";
import { tipoClientesB2bFullfilledReducer } from "./redux/tipoClientesB2b";
import { tipoDevolucionesFullfilledReducer } from "./redux/tipoDevoluciones";
import { tipoFacturasFullfilledReducer } from "./redux/tipoFacturas";
import { tipoGarantiasFullfilledReducer } from "./redux/tipoGarantias";
import { tipoIncidenciasFullfilledReducer } from "./redux/tipoIncidencias";
import { subtiposIncidenciaFullfilledReducer } from "./redux/subtiposIncidencia";
import { tipoPiezasFullfilledReducer } from "./redux/tipoPiezas";
import { usersReducer } from "./redux/users";
import { ventasReducer } from "./redux/ventas";
import { avisosReducer } from "./redux/avisos";
import { fichaIncidenciaReducer, currentIncidenciaStatusReducer } from "./redux/features/fichaIncidencia";
import { dashboardReducer } from "./redux/features/dashboard";
import { currentClienteReducer, currentClienteStatusReducer } from "./redux/features/currentCliente";
import { currentUserReducer, currentUserStatusReducer } from "./redux/features/currentUser";
import { currentPiezaReducer } from "./redux/features/currentPieza";
import { currentProveedorReducer } from "./redux/features/currentProveedor";
import { fichaClienteReducer, fichaClienteStatusReducer } from "./redux/features/fichaCliente";
import { fichaProveedorReducer, fichaProveedorStatusReducer } from "./redux/features/fichaProveedor";
import { tarifasFullfilledReducer } from "./redux/tarifas";
import { stepsFullfilledReducer } from "./redux/incidenciaSteps";
import { avisosListReducer, avisosListStatusReducer } from "./redux/features/avisosList";
import { administracionFullfilledReducer, atencionClienteFullfilledReducer, comercialesFullfilledReducer, recambistasFullfilledReducer,  } from "./redux/features/tipoUsers";
import { readOnlyReducer } from "./redux/readOnly";
import { notificacionesReducer } from "./redux/features/notificaciones";
import { serviciosEnvioFullfilledReducer } from "./redux/serviciosEnvio";
import { transportistasFullfilledReducer } from "./redux/transportistas";
import { enviosReducer } from "./redux/envios";
import { comercialDetailReducer } from "./redux/comercial_detail";
import { fichaPresupuestoReducer, fichaPresupuestoStatusReducer } from "./redux/features/fichaPresupuesto";
import { subestadosIncidenciaFullfilledReducer } from "./redux/subestadosIncidencia";
import { recordatoriosClientesReducer } from "./redux/features/recordatoriosClientes";
import { facturasDesguacesReducer } from "./redux/facturasDesguaces";
import { loadingReducer } from "./redux/features/loading";
import { dashboardVehiculosReducer } from "./redux/features/vehiculos";
import { devolucionesMercanciasReducer } from "./redux/devoluciones_mercancias";
import { estadosPiezasFullfilledReducer } from "./redux/estadosPiezas";
import { desguacesFullfilledReducer } from "./redux/desguaces";
import { tipoPagosFullfilledReducer } from "./redux/tipoPagos";
import { plantillasEmailFullfilledReducer } from "./redux/plantillasEmail";
import { notasCargoReducer } from "./redux/notasCargo";
import { ventasPendientesReducer } from './redux/ventasPendientes';

const reducer = combineReducers({
    // UTILITIES
    search: searchReducer,
    // DATA LIST
    avisos: avisosReducer,
    clientes: clientesReducer,
    presupuestos: presupuestosReducer,
    envios: enviosReducer,
    devoluciones: devolucionesReducer,
    devolucion_mercancias: devolucionesMercanciasReducer,
    piezas_reservadas: piezasReservadasReducer,
    facturas: facturasReducer,
    facturas_desguaces: facturasDesguacesReducer,
    notas_cargo: notasCargoReducer,
    incidencias: incidenciasReducer,
    notificaciones: notificacionesReducer,
    proveedores: proveedoresReducer,
    detalles: comercialDetailReducer,
    users: usersReducer,
    ventas: ventasReducer,
    ventas_pendientes: ventasPendientesReducer,
    // READ ONLY DATA
    read_only: readOnlyReducer,
    //-------------------------------
    tipo_clientes: tipoClientesFullfilledReducer,
    tipo_clientes_b2b: tipoClientesB2bFullfilledReducer,
    poblaciones: poblacionesFullfilledReducer,
    paises: paisesFullfilledReducer,
    roles: rolesFullfilledReducer,
    estados_venta: estadosVentaFullfilledReducer,
    estados_incidencia: estadosIncidenciaFullfilledReducer,
    subestados_incidencia: subestadosIncidenciaFullfilledReducer,
    tipo_facturas: tipoFacturasFullfilledReducer,
    tipo_piezas: tipoPiezasFullfilledReducer,
    familia_piezas: familiaPiezaFullfilledReducer,
    tipo_garantias: tipoGarantiasFullfilledReducer,
    tipo_devoluciones: tipoDevolucionesFullfilledReducer,
    tipo_incidencias: tipoIncidenciasFullfilledReducer,
    subtipos_incidencia: subtiposIncidenciaFullfilledReducer,
    marcas: marcasFullfilledReducer,
    modelos: modelosFullfilledReducer,
    plataformas: plataformasFullfilledReducer,
    tarifas: tarifasFullfilledReducer,
    steps: stepsFullfilledReducer,
    transportistas: transportistasFullfilledReducer,
    servicios_envio: serviciosEnvioFullfilledReducer,
    recambistas: recambistasFullfilledReducer,
    comerciales: comercialesFullfilledReducer,
    atencion_cliente: atencionClienteFullfilledReducer,
    administracion: administracionFullfilledReducer,
    estados_piezas: estadosPiezasFullfilledReducer,
    desguaces: desguacesFullfilledReducer,
    tipo_pagos: tipoPagosFullfilledReducer,
    plantillas_email: plantillasEmailFullfilledReducer,
    //-------------------------------
    // CURRENT DATA
    loading: loadingReducer,
    dashboard: dashboardReducer,
    vehiculos: dashboardVehiculosReducer,
    presupuesto: combineReducers({
        entity: fichaPresupuestoReducer,
        status: fichaPresupuestoStatusReducer
    }),
    currentIncidencia: combineReducers({
        entity: fichaIncidenciaReducer,
        status: currentIncidenciaStatusReducer
    }),
    currentCliente: combineReducers({
        entity: currentClienteReducer,
        status: currentClienteStatusReducer
    }),
    currentUser: combineReducers({
        entity: currentUserReducer,
        status: currentUserStatusReducer
    }),
    currentPieza: currentPiezaReducer,
    currentProveedor: currentProveedorReducer,
    fichaCliente: combineReducers({
        entity: fichaClienteReducer,
        status: fichaClienteStatusReducer
    }),
    fichaProveedor: combineReducers({
        entity: fichaProveedorReducer,
        status: fichaProveedorStatusReducer
    }),
    avisosList: combineReducers({
        entity: avisosListReducer,
        status: avisosListStatusReducer
    }),
    recordatorios: recordatoriosClientesReducer
})

const rootReducer = reducer;

export default rootReducer;